import React from "react";
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import SupplierCreateGlobal from '../../supplier/Supplier.create.global';

function ProductSupplierModal({ show, onHide }) {
    return (
        <Modal centered dialogClassName="modal-container" show={show} onHide={onHide} size="md" animation={true}>
            <Modal.Header closeButton> <Modal.Title>Supplier Information</Modal.Title> </Modal.Header>
            <Modal.Body>
                <SupplierCreateGlobal pageOrigin="item"/>
            </Modal.Body>
        </Modal>
    )
}

const mapStateToProps = state => ({
	// supplier: state.supplier
});

export default connect(mapStateToProps, {})(ProductSupplierModal);

